const pastoralFormModule = {

    state: {
        pastoralFormActive: false
    },

    mutations: {
        SOCKET_PASTORAL_FORM_ACTIVE(state, active) {
            state.pastoralFormActive = active
        }
    },

    actions: {
        socket_pastoral_form_active: ({ state, rootState }) => {
            rootState.io.emit('pastoral_form_active', state.pastoralFormActive);
        }
    }
}

export default pastoralFormModule;